import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AdminManagementRoutes from '../admin-management/admin-management.routes';
import BadgeRoutes from '../badge/badge.routes';
import TagRoutes from '../tag/tag.routes';
import TermsAndConditionsRoutes from '../terms-and-conditions/terms-and-conditions.routes';
import PrivacyPolicyRoutes from '../privacy-policy/privacy-policy.routes';
import UserReportRoutes from '../user-report/user-report.routes';
import CommunityManagementRoutes from '../community-management/community-management.routes';
import CuratedContentRoutes from '../curated-content/curated-content.routes';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/admin-management/*" element={<AdminManagementRoutes />} />
      <Route path="/badge/*" element={<BadgeRoutes />} />
      <Route path="/tag/*" element={<TagRoutes />} />
      <Route path="/terms-and-conditions/*" element={<TermsAndConditionsRoutes />} />
      <Route path="/privacy-policy/*" element={<PrivacyPolicyRoutes />} />
      <Route path="/user-report/*" element={<UserReportRoutes />} />
      <Route path="/community-management/*" element={<CommunityManagementRoutes />} />
      <Route path="/curated-content/*" element={<CuratedContentRoutes />} />
      {/* Add other admin routes here as needed */}
    </Routes>
  );
};

export default AdminRoutes; 